import { render, staticRenderFns } from "./BankContactNumber.vue?vue&type=template&id=e658c1e0"
import script from "./BankContactNumber.vue?vue&type=script&lang=js"
export * from "./BankContactNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports